module.exports = __webpack_public_path__ + "img/service_5.svg";